var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { btnSizeToIconSize } from '../Button/Button';
import React from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import { Icon } from '../Icon';
import { AnchorButtonVariant, BtnVariantIconWrapper } from './ButtonVariant';
import { Anchor, IconWrapper } from './elements';
export var Link = React.forwardRef(function (_a, fRef) {
    var _b = _a.anchorClassName, anchorClassName = _b === void 0 ? '' : _b, _c = _a.iconClassName, iconClassName = _c === void 0 ? '' : _c, _d = _a.color, color = _d === void 0 ? 'primary' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, iconSrc = _a.iconSrc, _f = _a.iconSide, iconSide = _f === void 0 ? 'left' : _f, _g = _a.variant, variant = _g === void 0 ? 'default' : _g, _h = _a.btnVariantProps, btnVariantProps = _h === void 0 ? {
        btnSize: 'medium',
        btnVariant: 'default'
    } : _h, children = _a.children, restProps = __rest(_a, ["anchorClassName", "iconClassName", "color", "disabled", "iconSrc", "iconSide", "variant", "btnVariantProps", "children"]);
    var renderIcon = function () {
        return variant === 'button' ? (React.createElement(BtnVariantIconWrapper, { "$iconSide": iconSide, "$size": btnVariantProps.btnSize, "$childrenPresent": !!children },
            React.createElement(Icon, { src: iconSrc, size: btnSizeToIconSize[btnVariantProps.btnSize], fill: "currentColor" }))) : (React.createElement(IconWrapper, { "$iconSide": iconSide, className: iconClassName },
            React.createElement(Icon, { src: iconSrc, size: "small", fill: "currentColor", "data-testid": "link-icon-".concat(iconSide) })));
    };
    return (React.createElement(InternalProvider, null,
        variant === 'default' && (React.createElement(Anchor, __assign({ "$color": color, className: "".concat(disabled ? 'disabled' : '', " ").concat(anchorClassName), ref: fRef, "$iconPresent": !!iconSrc, "aria-disabled": disabled ? true : undefined, tabIndex: disabled ? -1 : undefined }, restProps),
            iconSrc && iconSide === 'left' && renderIcon(),
            children,
            iconSrc && iconSide === 'right' && renderIcon())),
        variant === 'button' && (React.createElement(AnchorButtonVariant, __assign({ ref: fRef, className: "".concat(disabled ? 'disabled' : '', " ").concat(anchorClassName), "$childrenPresent": !!children, "$iconPresent": !!iconSrc, "$iconSide": iconSide, "$useFigmaStyles": false, "$btnColor": color === 'primary' ? 'primary' : 'secondary', "$btnSize": btnVariantProps.btnSize, "$btnVariant": btnVariantProps.btnVariant, "aria-disabled": disabled ? true : undefined, tabIndex: disabled ? -1 : undefined }, restProps),
            iconSrc && iconSide === 'left' && renderIcon(),
            children,
            iconSrc && iconSide === 'right' && renderIcon()))));
});
